import { render } from "./breadcrumb-index.vue?vue&type=template&id=6ab5abae&scoped=true"
import script from "./breadcrumb-index.vue?vue&type=script&lang=js"
export * from "./breadcrumb-index.vue?vue&type=script&lang=js"

import "./breadcrumb-index.vue?vue&type=style&index=0&id=6ab5abae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab5abae"]])

export default __exports__